export default "__VITE_ASSET__BT46nBPn__"